import React, { useState } from 'react';
import { Alert, Snackbar, Box } from '@mui/material';
import Navbar from './common/Navbar';
import Footer from './common/Footer';
import AppRoutes from '../routes';
import { useSessionTimeout } from '../hooks/useSessionTimeout';

const AppContent: React.FC = () => {
    const [sessionExpiredAlert, setSessionExpiredAlert] = useState(false);

    // Initialize session timeout hook inside Router context
    useSessionTimeout({
        timeoutDelay: 300000, // 5 minutes after session expires
        checkInterval: 30000,  // Check every 30 seconds
        onSessionExpired: () => {
            setSessionExpiredAlert(true);
        },
        onBeforeLogout: () => {
            setSessionExpiredAlert(false);
        }
    });

    const handleCloseAlert = () => {
        setSessionExpiredAlert(false);
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', //minHeight: '100vh' 
            }}>
            <Navbar />
            <Box sx={{ flex: 1, minHeight: 'calc(100vh - 200px)' }}>
                <AppRoutes />
            </Box>
            <Footer />
            
            <Snackbar
                open={sessionExpiredAlert}
                autoHideDuration={null} // Don't auto hide
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert 
                    severity="warning" 
                    onClose={handleCloseAlert}
                    sx={{ width: '100%' }}
                >
                    Your session has expired. You will be automatically logged out in 5 minutes unless you refresh the page or take an action.
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default AppContent;